import { render, staticRenderFns } from "./PublishComment.vue?vue&type=template&id=3d58e0a4&scoped=true"
import script from "./PublishComment.vue?vue&type=script&lang=js"
export * from "./PublishComment.vue?vue&type=script&lang=js"
import style0 from "./PublishComment.vue?vue&type=style&index=0&id=3d58e0a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d58e0a4",
  null
  
)

export default component.exports